import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form'
import { i18nReducer } from 'redux-react-i18n';
import commonReducer from './common-reducer';
import loginReducer from '../../models/login/login.reducer';
import workItemReducer from "./work-item-reducer";
import ballotReducer from "./ballot-reducer";
import ansiReducer from './ansi-reducer';

/** Add Multiple Reducer */
const reducers = {
  i18nReducer,
  form,
  commonReducer: commonReducer,
  loginReducer:loginReducer,
  workItemReducer: workItemReducer,
  ballotReducer: ballotReducer,
  ansiReducer:ansiReducer
};

export default combineReducers(reducers);
